import React from 'react';
import {TopHeaderBar, TopHeaderBarWrapper} from '../../../forecast-app/shared/components/headers/top-header-bar/TopHeaderBar';
import {buildThirdLevelNavHeader} from '../../../forecast-app/shared/components/headers/header-bar/header_bar';
import {BUTTON_COLOR, BUTTON_STYLE, ELEMENT_TYPE} from '../../../constants';

export const getProjectHealthTopHeader = intl => {
	const content = [];
	const onboardingFlows = [];

	const onboardingComponent = {
		id: 'onboarding-component',
		intl: intl,
		type: TopHeaderBar.TYPE.ONBOARDING,
		title: 'Learn to use Project Health',
		options: onboardingFlows,
	};
	content.push(onboardingComponent);

	content.push({
		type: TopHeaderBar.TYPE.BETA,
	});

	return (
		<TopHeaderBarWrapper sidePadding={24} bottomPadding={16}>
			<TopHeaderBar title={'Nova Insights'} content={content} />
		</TopHeaderBarWrapper>
	);
};

export const getProjectHealthHeader = (intl, projectDisabled) => {
	const leftContent = [];
	const rightContent = [];

	const button = {
		type: ELEMENT_TYPE.BUTTON,
		text: intl.formatMessage({id: 'settings.project-status'}),
		style: BUTTON_STYLE.OUTLINE,
		color: BUTTON_COLOR.PURPLE,
		dataCy: '-button',
		disabled: projectDisabled,
	};
	rightContent.push(button);
	return buildThirdLevelNavHeader(leftContent, rightContent);
};
